import { useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { fetchPaymentTokens } from 'lib/core/data/customer/paymentTokens'
import { getPaymentTokens, getSlice } from 'lib/core/data/customer/paymentTokens/selectors'
import { PaymentToken } from 'lib/core/data/customer/paymentTokens/types'

interface UseCustomerPaymentTokensParams {
  paymentMethodCode?: string
}

type UseCustomerPaymentTokens = (params?: UseCustomerPaymentTokensParams) => {
  isFetching: boolean
  paymentTokens: PaymentToken[]
  fetchPaymentTokens: () => void
}

export const useCustomerPaymentTokens: UseCustomerPaymentTokens = (params) => {
  const dispatch = useDispatch()
  const methodCode = params?.paymentMethodCode
  const { isFetching } = useSelector(getSlice)
  const paymentMethodTokensSelector = useMemo(() => getPaymentTokens(methodCode), [methodCode])
  const paymentTokens = useSelector(paymentMethodTokensSelector)

  return {
    isFetching,
    paymentTokens,
    fetchPaymentTokens: useMemo(() => () => {
      dispatch(fetchPaymentTokens())
    }, [dispatch])
  }
}
